
export default {
    name: 'Navbar',
    data() {
        return {
            lastScroll: 0
        }
    },
    methods: {
        goHome() {
            this.$router.push({ name: 'Home' })
        },
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            if (Math.abs(currentScrollPosition - this.lastScroll) < 60) {
                return
            }
            this.lastScroll = currentScrollPosition
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    }
}